import fetchServer from "../fetchServer";

export default async function adminClaimReward(code, cancelToken) {
  let result = { return: 0, msg: "Something went wrong logging user!" };

  await fetchServer({
    method: "POST",
    url: `/admin/rewards/claim`,
    data: {
      rewardCode: code,
    },
    cancelToken,
  })
    .then((res) => {
      if (res?.status === 200) {
        result = { return: 1, msg: "Welcome", data: res.data };
      } else {
        result["msg"] = res?.data?.error || result["msg"];
        result["data"] = res?.data;
      }
    })
    .catch((err) => {
      result["msg"] = err.message;
    });
  return result;
}
